import React from "react";
import { graphql, PageProps } from "gatsby";

import { homePagePrepareData } from "utils/homePagePrepareData";
import { BaseLayout } from "layouts/BaseLayout";
import { Collaborations } from "components/common/Collaborations";
import { LatestUpdates } from "components/common/LatestUpdates";
import { Hero } from "components/home/Hero";
import { Products } from "components/home/Products";
import { Partners } from "components/home/Partners";

export const query = graphql`
  query HomePage {
    prismicHomePage {
      data {
        title {
          text
        }
        description {
          text
        }
        image {
          url
        }
        header {
          text
        }
        button_text {
          text
        }
        button_text_mobile {
          text
        }
        products {
          product {
            document {
              ... on PrismicProduct {
                id
                data {
                  name {
                    text
                  }
                  long_description {
                    text
                  }
                  links {
                    label {
                      text
                    }
                    link {
                      url
                    }
                  }
                  preview_image {
                    gatsbyImageData(
                      width: 336
                      placeholder: BLURRED
                      outputPixelDensities: 1.5
                    )
                  }
                  main_link_label {
                    text
                  }
                  main_link {
                    url
                  }
                }
              }
            }
          }
        }
        partners {
          label {
            text
          }
          link {
            url
          }
          icon {
            gatsbyImageData(
              width: 32
              placeholder: BLURRED
              outputPixelDensities: 1.5
            )
          }
        }
        news {
          title {
            text
          }
          link {
            url
          }
          desscription {
            text
          }
          date(formatString: "DD.MM.YYYY")
        }
        news_link {
          url
        }
      }
    }
  }
`;

const IndexPage = ({ data }: PageProps<any>) => {
  const { seo, hero, products, partners, news, newsLink } =
    homePagePrepareData(data);

  return (
    <BaseLayout seo={seo}>
      <Hero header={hero.header} button={hero.button} />
      <Products products={products} />
      <Partners partners={partners} news={news} newsLink={newsLink} />
      <Collaborations />
      <LatestUpdates />
    </BaseLayout>
  );
};

export default IndexPage;
